import { useAuthStore } from '@/stores'

function checkPermission(binding) {
  const authStore = useAuthStore()
  const perms = authStore.allPermissions

  const value = binding.value

  // check if it's super admin
  if (authStore.isSuperAdmin) return true

  // simple string: v-can="'edit_policy'"
  if (typeof value === 'string') {
    return perms.includes(value)
  }

  // object: { any: ['edit_policy', 'view_policy'], all: [...] }
  if (value?.any) {
    return value.any.some(p => perms.includes(p))
  }

  if (value?.all) {
    return value.all.every(p => perms.includes(p))
  }

  return false
}

export const vCan = {
  mounted(el, binding) {
    if (!checkPermission(binding)) {
      el.remove()
    }
  },

  updated(el, binding) {
    if (!checkPermission(binding)) {
      el.remove()
    }
  }
}
